import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false, // ❗ مهم جداً
});

// إضافة token لكل الطلبات
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken"); // ✔ تم إصلاح الخطأ هنا
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Get all admin accounts
export const getAdminAccounts = async () => {
  try {
    const response = await apiClient.get("/get/admin/accounts", {
      params: {
        api_password: "Project102$_",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching admin accounts:", error);
    throw error;
  }
};

/**
 * Create a new admin account
 * payload: { email, password, name, phone, type? , ... }
 * Returns response.data
 */
export const createAdminAccount = async (payload = {}) => {
  try {
    const formData = new FormData();
    if (payload.email) formData.append("email", payload.email);
    if (payload.password) formData.append("password", payload.password);
    if (payload.name) formData.append("name", payload.name);
    if (payload.phone) formData.append("phone", payload.phone);
    // append any optional fields if provided
    if (payload.type) formData.append("type", payload.type);
    if (payload.note) formData.append("note", payload.note);

    const response = await apiClient.post("/add/new/admin/account", formData, {
      params: {
        api_password: "Project102$_",
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating admin account:", error);
    throw error;
  }
};

/**
 * Update an existing admin account
 * @param {number} accountId - ID of the account to update
 * @param {object} payload - { email?, password?, name?, phone? }
 * @returns {Promise} Response data
 */
export const updateAdminAccount = async (accountId, payload = {}) => {
  try {
    const formData = new FormData();
    if (payload.email) formData.append("email", payload.email);
    if (payload.password) formData.append("password", payload.password);
    if (payload.name) formData.append("name", payload.name);
    if (payload.phone) formData.append("phone", payload.phone);

    const response = await apiClient.post(`/edite/admin/account/${accountId}`, formData, {
      params: {
        api_password: "Project102$_",
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating admin account:", error);
    throw error;
  }
};
